
import router from '../router';
import axios from 'axios';
import user from './user';
import store from '../store';

let API_URL = 'https://api.escapeitkit.com:443/';
if (location.hostname === 'localhost') {
    API_URL = 'http://localhost:9000/';
}

export default {
    init: function() {
        // First load or refresh: check to see if they have a token and get user from server, commit it to store
        if (localStorage.getItem('id_token') && localStorage.getItem('access_token')) {
            user.getCurrentUser().then(user => {
                store.commit('user/setUser', user);
                console.log('Auth: User logged in.');
            }, err => {
                localStorage.removeItem('id_token');
                localStorage.removeItem('access_token');
                router.push({name: 'Login'});
            });
        } else {
            localStorage.removeItem('id_token');
            localStorage.removeItem('access_token');
            router.push({name: 'Login'});
        }
    },

    login: function(credentials) {
        return new Promise((resolve, reject) => {
            axios.post(API_URL + 'auth/local/', credentials).then(response => {
                localStorage.setItem('id_token', response.data.id_token);
                localStorage.setItem('access_token', response.data.access_token);

                user.getCurrentUser().then(user => {
                    store.commit('user/setUser', user);
                    resolve();
                }, reject);
            }, err => {
                localStorage.removeItem('id_token');
                localStorage.removeItem('access_token');
                reject(err.response.data);
            });
        });
    },

    signup: function(details) {
        return new Promise((resolve, reject) => {
            axios.post(API_URL + 'api/users/', details).then(response => {
                localStorage.setItem('id_token', response.data.id_token);
                localStorage.setItem('access_token', response.data.access_token);

                user.getCurrentUser().then(user => {
                    store.commit('user/setUser', user);
                    resolve();
                }, reject);
            }, err => {
                localStorage.removeItem('id_token');
                localStorage.removeItem('access_token');
                reject(err.response.data);
            });
        });
    },

    logout: function() {
        router.push({name: 'Login'});
        localStorage.removeItem('id_token');
        localStorage.removeItem('access_token');
        store.commit('user/setUser', null);  // TODO this is crashing if you are on a page that uses data from it.
        store.commit('setSocketType', null);
    },

    // The object to be passed as a header for authenticated requests
    getAuthHeader() {
        return {
            'Authorization': 'Bearer ' + localStorage.getItem('id_token')
        };
    }
}


// WEBPACK FOOTER //
// ./src/services/auth.js